var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20824"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.23076 2.23076C3.84454 0.616988 6.25938 0 9.37209 0H16.6279C19.7406 0 22.1555 0.616988 23.7692 2.23076C25.383 3.84454 26 6.25938 26 9.37209V16.6279C26 19.7406 25.383 22.1555 23.7692 23.7692C22.1555 25.383 19.7406 26 16.6279 26H9.37209C6.25938 26 3.84454 25.383 2.23076 23.7692C0.616988 22.1555 0 19.7406 0 16.6279V9.37209C0 6.25938 0.616988 3.84454 2.23076 2.23076ZM3.51342 3.51342C2.40627 4.62058 1.81395 6.43829 1.81395 9.37209V16.6279C1.81395 19.5617 2.40627 21.3794 3.51342 22.4866C4.62058 23.5937 6.43829 24.186 9.37209 24.186H16.6279C19.5617 24.186 21.3794 23.5937 22.4866 22.4866C23.5937 21.3794 24.186 19.5617 24.186 16.6279V9.37209C24.186 6.43829 23.5937 4.62058 22.4866 3.51342C21.3794 2.40627 19.5617 1.81395 16.6279 1.81395H9.37209C6.43829 1.81395 4.62058 2.40627 3.51342 3.51342Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6235 12.9998C16.6235 12.332 17.165 11.7905 17.8328 11.7905H17.8436C18.5115 11.7905 19.0529 12.332 19.0529 12.9998C19.0529 13.6677 18.5115 14.2091 17.8436 14.2091H17.8328C17.165 14.2091 16.6235 13.6677 16.6235 12.9998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7852 12.9998C11.7852 12.332 12.3266 11.7905 12.9945 11.7905H13.0053C13.6732 11.7905 14.2146 12.332 14.2146 12.9998C14.2146 13.6677 13.6732 14.2091 13.0053 14.2091H12.9945C12.3266 14.2091 11.7852 13.6677 11.7852 12.9998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.94678 12.9998C6.94678 12.332 7.4882 11.7905 8.15608 11.7905H8.16694C8.83482 11.7905 9.37624 12.332 9.37624 12.9998C9.37624 13.6677 8.83482 14.2091 8.16694 14.2091H8.15608C7.4882 14.2091 6.94678 13.6677 6.94678 12.9998Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.7f5ef8955c5293ceee55483d9ad056d8.svg";
export { ForwardRef as ReactComponent };